import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export interface MessageDialogCloseEvent {
  confirmed: boolean;
  data?: any;
}

@Component({
  selector: 'app-yes-no-message-dialog',
  imports: [],
  templateUrl: './yes-no-message-dialog.html',
  styleUrl: './yes-no-message-dialog.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(document:keydown.escape)': 'onEscape()',
  },
})
export class YesNoMessageDialog {
  private static nextId = 0;

  readonly title = input.required<string>();
  readonly message = input.required<string>();
  readonly okButton = input<string>('Ok');
  readonly cancelButton = input<string>('Abbruch');
  readonly isOpen = input(false);
  readonly closeOnBackdrop = input(true);
  readonly data = input<any>();

  readonly confirmed = output<void>();
  readonly cancelled = output<void>();
  readonly closed = output<MessageDialogCloseEvent>();

  readonly titleId = `yes-no-dialog-title-${YesNoMessageDialog.nextId}`;
  readonly messageId = `yes-no-dialog-message-${YesNoMessageDialog.nextId++}`;

  onConfirm(): void {
    this.closed.emit({
      confirmed: true,
      data: this.data()
    } as MessageDialogCloseEvent);
    this.confirmed.emit(this.data());
  }

  onCancel(): void {
    this.closed.emit({
      confirmed: false,
      data: this.data()
    });
    this.cancelled.emit();
  }

  onEscape(): void {
    if (!this.isOpen()) {
      return;
    }

    this.onCancel();
  }

  onBackdropClick(event: MouseEvent): void {
    if (!this.closeOnBackdrop()) {
      return;
    }

    if (event.target === event.currentTarget) {
      this.onCancel();
    }
  }
}
